module.exports = __webpack_public_path__ + "img/logo-p.b78cf2aa.png";